module.exports = __webpack_public_path__ + "static/media/SJE089_01.f6cc9e97.jpg";